import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useDatePickerColumn,
  useCreateModal,
  BaseButtonMore,
  BaseButton,
  XrkMessage,
  BaseDialog,
  BaseTextContent
} from 'xrk-components';
import { formatter } from '@/utils';
import {
  costItemList,
  costItemDownload,
  costItemExport
} from '../../data-source/apis';
import CostDetailDialog from './cost-detail-dialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'cost-list-dialog',
  props: {
    remove: { type: Function },
    individualId: {}
  },
  setup(__props: any) {

const props = __props;

const xrkTableRef = ref();

const getListAjax = params => {
  const { incomeMonth, ...args } = params;
  return costItemList({ individualId: props.individualId, ...args });
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: [
    useDatePickerColumn({
      prop: 'incomeMonth',
      label: '所属月份',
      config: {
        type: 'monthrange',
        valueFormat: 'YYYY-MM',
        startPlaceholder: '开始月份',
        endPlaceholder: '结束月份',
        clearable: true
      },
      listener: {
        onChange: (value, searchObj) => {
          if (!value) {
            searchObj.startAt = '';
            searchObj.endAt = '';
          } else {
            searchObj.startAt = value[0];
            searchObj.endAt = value[1];
          }
        }
      }
    })
  ],
  searchBtn: { show: true, text: '搜索' },
  resetBtn: { show: true, text: '重置' },
  otherComponents: [
    {
      render() {
        return (
          <>
            <BaseButton
              type="primary2"
              click={async () => {
                const selectionRows =
                  xrkTableRef.value.getSelectionRows() || [];
                if (!selectionRows?.length) {
                  XrkMessage.warning('请选择需要导出的数据');
                  return;
                }
                await costItemExport({
                  individualId: props.individualId,
                  ids: selectionRows.map(item => item.id).join(',')
                });
                XrkMessage.success('操作成功，请前往下载中心进行下载查看');
              }}
            >
              导出附件
            </BaseButton>
          </>
        );
      }
    }
  ]
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  baseConfig: { rowKey: 'id' },
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: 'id',
      align: 'center',
      fixed: 'left',
      width: 120
    }),
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px',
      fixed: 'left'
    }),
    useTableColumn({
      label: '所属月份',
      prop: 'incomeMonth'
    }),
    useTableColumn({
      label: '提交时间',
      prop: 'submitAt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),

    useTableColumn({
      label: '操作',
      prop: 'handlerCol',
      fixed: 'right',
      width: '140px',
      render: ({ row }) => {
        const btns = [
          {
            content: '查看',
            click: () => {
              useCreateModal(CostDetailDialog, {
                id: row.id
              });
            }
          },
          {
            content: '下载',
            click: async () => {
              await costItemDownload({
                id: row.id,
                individualId: props.individualId
              });
            }
          }
        ].filter(Boolean);
        return (
          <BaseButtonMore
            key={Date.now()}
            maxCount={2}
            style={{ 'justify-content': 'right' }}
            btns={btns}
          ></BaseButtonMore>
        );
      }
    })
  ].filter(item => item)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "960px",
    title: "成本列支明细",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        onClick: _ctx.remove,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("关闭")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(XrkTable), {
            ref_key: "xrkTableRef",
            ref: xrkTableRef,
            getListAjax: getListAjax,
            searchConfig: searchConfig.value,
            tableConfig: tableConfig.value
          }, null, 8, ["searchConfig", "tableConfig"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})